<template>
  <el-select
    :value="value"
    @input="change"
    clearable
    placeholder="请选择"
    class="whole-row">
    <el-option label="启用" :value="1" />
    <el-option label="停用" :value="-1" />
  </el-select>
</template>
<script>

export default {
  props:['value'],
  data() {
    return {
      options: []
    }
  },
  created() {},
  methods: {
    change(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>